import links from "@/links/links";

export default {
  actions: {
    FETCH_BY_MANDATE(mandateId) {
      return this.get(links.RESOLUTION_VOTES_FETCH_BY_MANDATE(mandateId), {
        dataKey: "hydra:member",
      });
    },
    FETCH(meetingResolutionId) {
      return this.get(links.RESOLUTION_VOTE_FETCH(meetingResolutionId), {
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.RESOLUTION_VOTE_GET(id));
    },
    POST(item) {
      return this.post(links.RESOLUTION_VOTE_POST(), item);
    },
    PUT(item, save = true) {
      return this.put(links.RESOLUTION_VOTE_PUT(item.id), item, { save: save });
    },
    BULK_POST(Obj) {
      return this.post(links.RESOLUTION_VOTE_BULK_CREATE(), Obj);
    },
    BULK_PUT(Obj) {
      return this.post(links.RESOLUTION_VOTE_BULK_UPDATE(), Obj);
    },
    BULK_DELETE(items) {
      return this.post(links.RESOLUTION_VOTE_BULK_DELETE(), items);
    },
    BULK_VOTE(postObj) {
      return this.post(links.RESOLUTION_VOTE_BULK_VOTE(), postObj, {
        save: false,
      });
    },
    RESET_IGNORED_CORRESPONDENCE(ignoredCorrespondenceVotes, meetingId) {
      return this.post(
        links.RESET_IGNORED_CORRESPONDENCE(),
        {
          items: ignoredCorrespondenceVotes,
          meeting_id: meetingId,
        },
        {
          save: false,
        }
      );
    },
    GET_IGNORED_CORRESPONDENCE(meetingId) {
      return this.get(links.RESOLUTION_VOTE_GET_IGNORED_CORRESPONDENCE(meetingId), {
        dataKey: "hydra:member",
      });
    },
    GET_BY_MEETING(meetingId) {
      return this.get(links.RESOLUTION_VOTE_BY_MEETING(meetingId), {
        dataKey: "hydra:member",
      });
    },
  },
};
